import { createApp } from 'vue';
import { createVfm } from 'vue-final-modal'
import Notifications from '@kyvg/vue3-notification';
import App from './prime/App.vue';

(function (){
    const el = document.getElementById('tariff-form');

    createApp(App)
        .use(createVfm())
        .use(Notifications)
        .mount(el);

    document.querySelectorAll('.prime-faq-item__header').forEach((item) => {
        item.addEventListener('click', () => {
            const parent = item.closest('.prime-faq-item');

            if (!parent) return;

            if (parent.classList.contains('active')) {
                parent.classList.remove('active');
            } else {
                parent.classList.add('active');
            }
        });
    })
}());

